import Vue from 'vue'
import App from './App'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(VueCookies)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App)
})

if (location.pathname && location.pathname.indexOf('/link') === 0) {
    function isIOS(userAgent) {
        if (/(iPhone|iPad|iPod|iOS)/i.test(userAgent)) {
            console.log('isIOS');
            return true;
        } else if (/(Android)/i.test(userAgent)) {
            console.log('isAndroid');
            return false;
        } else {
            console.log('isPC');
            return false;
        }
    }
    if (isIOS(navigator.userAgent)) {
        location.href = 'https://apps.apple.com/app/punball/id1585781366'
    } else {
        location.href = 'https://play.google.com/store/apps/details?id=com.habby.punball'
    }
}



// WEBPACK FOOTER //
// ./src/main.js